import React from 'react';
import { CalendarIcon, MailIcon, MapPinIcon } from 'lucide-react';
import { ConsultationForm } from '../components/ConsultationForm';
import { LinkedInIcon } from '../components/LinkedInIcon';
import { contactDetails } from '../data/content';
const nextSteps = ['Dr. Vecchione personally reviews your request within one business day.', 'You receive an invitation to a complimentary 30-minute strategy session.', 'Together you define the engagement scope, timeline, and positioning goals.'];
export function Contact() {
  return <section className="bg-ivory" aria-labelledby="contact-heading" data-id="element-218" data-mp="t35sp4cg17j8">
      <div className="mx-auto grid max-w-7xl gap-14 px-6 py-16 lg:grid-cols-12 lg:gap-16 lg:px-8 lg:py-24" data-id="element-219" data-mp="17qqrwn676mlv">
        <div className="lg:col-span-5" data-id="element-220" data-mp="12yqxtbct6nx7">
          <p className="flex items-center gap-3 text-sm font-medium text-steel" data-id="element-221" data-mp="12xpeykpjwx4x">
            <span className="h-px w-10 bg-gold" aria-hidden="true" data-id="element-222" data-mp="f8d5rku84p2m" />
            Contact
          </p>
          <h1 id="contact-heading" className="mt-6 font-serif text-4xl leading-[1.1] text-navy sm:text-5xl" data-id="element-223" data-mp="aauuhnsqhxrg">
            Ready to Elevate Your Executive Narrative?
          </h1>
          <p className="mt-6 text-lg leading-relaxed text-steel" data-id="element-224" data-mp="19fpjq1054dyp">
            Whether you are targeting your next C-suite milestone, navigating a complex transition, or building a
            board dossier, let&rsquo;s position your value for maximum impact.
          </p>

          <h2 className="mt-12 text-sm font-semibold text-navy" data-id="element-225" data-mp="mhcktygoj6gr">What happens next</h2>
          <ol className="mt-5 space-y-5" data-id="element-226" data-mp="qhwf8u9vbvz7">
            {nextSteps.map((s, i) => <li key={s} className="flex gap-4" data-id="element-227" data-mp="vh923f0qp31s" data-mpi={i}>
                <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full border border-gold font-serif text-sm text-gold-dark" data-id="element-228" data-mp="vghk5702f3tz">
                  {i + 1}
                </span>
                <span className="pt-0.5 leading-relaxed text-charcoal" data-id="element-229" data-mp="26vmo0ebxn8f6">{s}</span>
              </li>)}
          </ol>

          <ul className="mt-12 space-y-4 border-t border-hairline pt-8 text-[15px]" data-id="element-230" data-mp="2bxlq7kvxrzaj">
            <li data-id="element-231" data-mp="1m5ipzxbknjar">
              <a href={`mailto:${contactDetails.email}`} className="inline-flex items-center gap-3 text-navy hover:underline" data-id="element-232" data-mp="1m96kozsr6br2">
                <MailIcon className="h-4 w-4 text-gold-dark" aria-hidden="true" data-id="element-233" data-mp="1w59osb760kgn" />
                {contactDetails.email}
              </a>
            </li>
            <li data-id="element-234" data-mp="1r781fe2phyzd">
              <a href={contactDetails.linkedin} target="_blank" rel="noreferrer" className="inline-flex items-center gap-3 text-navy hover:underline" data-id="element-235" data-mp="1r4lwlm779xku">
                <LinkedInIcon className="h-4 w-4 text-[#0A66C2]" data-id="element-236" data-mp="1d773o7hqn7o4" />
                {contactDetails.linkedinLabel}
              </a>
            </li>
            <li className="flex items-center gap-3 text-steel" data-id="element-237" data-mp="18eno54zhq2go">
              <MapPinIcon className="h-4 w-4 text-gold-dark" aria-hidden="true" data-id="element-238" data-mp="kpl1fiq01jfb" />
              {contactDetails.location}
            </li>
            <li className="flex items-center gap-3 text-steel" data-id="element-239" data-mp="fr1djcruhxkb">
              <CalendarIcon className="h-4 w-4 text-gold-dark" aria-hidden="true" data-id="element-240" data-mp="2rdlkvqp5x272" />
              {contactDetails.availability}
            </li>
          </ul>
        </div>

        <div className="lg:col-span-7" data-id="element-241" data-mp="2hgqphgo6rhx0">
          <ConsultationForm data-id="element-242" data-mp="2hhs3nu0i0kiy" />
        </div>
      </div>
    </section>;
}